module.exports = __webpack_public_path__ + "239559f6c37a7bd0a0f9ae0cb7f2d991.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/covers/field-trip.png
// module id = 912
// module chunks = 4